// lib/services/compute/animation_library_slot.ts

import BaseSlot from "./base_slot";
import CharacterBuilderGpu from "./character_builder_gpu";

/**
 * Holds references to the static GPU buffers produced by CharacterBuilderGpu.
 * This slot is permanent_ready: populated once during initialize() and never
 * recycled or re-leased. The pool returns this slot for every acquire call
 * without lease bookkeeping.
 */
export default class AnimationLibrarySlot extends BaseSlot {
  skeleton_buffer: GPUBuffer | null = null;
  inverse_bind_buffer: GPUBuffer | null = null;
  joint_map_buffer: GPUBuffer | null = null;
  clips_buffer: GPUBuffer | null = null;
  channels_buffer: GPUBuffer | null = null;
  times_buffer: GPUBuffer | null = null;
  values_buffer: GPUBuffer | null = null;
  character_constants_buffer: GPUBuffer | null = null;

  node_count = 0;
  joint_count = 0;
  clip_count = 0;
  channel_count = 0;
  mesh_node_index = 0;

  constructor() {
    super(true); // permanent_ready
  }

  populate_from(builder: CharacterBuilderGpu): void {
    this.skeleton_buffer = builder.skeleton_buffer;
    this.inverse_bind_buffer = builder.inverse_bind_buffer;
    this.joint_map_buffer = builder.joint_map_buffer;
    this.clips_buffer = builder.clips_buffer;
    this.channels_buffer = builder.channels_buffer;
    this.times_buffer = builder.times_buffer;
    this.values_buffer = builder.values_buffer;
    this.character_constants_buffer = builder.character_constants_buffer;

    this.node_count = builder.node_count;
    this.joint_count = builder.joint_count;
    this.clip_count = builder.clip_count;
    this.channel_count = builder.channel_count;
    this.mesh_node_index = builder.mesh_node_index;
  }

  /**
   * Permanent slots are not recycled. Override to be a no-op so the
   * pool's shutdown call cannot accidentally clear references while
   * GPU work still expects them.
   */
  recycle(): void {
    // intentionally empty
  }

  /**
   * Explicit clear for shutdown only. The owner of the slot (the pool)
   * calls this during its own shutdown when it's safe to drop references.
   */
  clear_references(): void {
    this.skeleton_buffer = null;
    this.inverse_bind_buffer = null;
    this.joint_map_buffer = null;
    this.clips_buffer = null;
    this.channels_buffer = null;
    this.times_buffer = null;
    this.values_buffer = null;
    this.character_constants_buffer = null;

    this.node_count = 0;
    this.joint_count = 0;
    this.clip_count = 0;
    this.channel_count = 0;
    this.mesh_node_index = 0;
  }
}